export default __webpack_public_path__ + "afa4cec5ba221e0ae45b6d731f95910d.png";